// extracted by mini-css-extract-plugin
module.exports = {"tabBar":"TabBar_tabBar__1CUN8","tab":"TabBar_tab__2A5tZ","activeTab":"TabBar_activeTab__24kgT"};